module.exports = __webpack_public_path__ + "img/UE4.7a62aa31.jpg";